import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/lib/auth';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import '@/App.css';

import Landing from '@/pages/Landing';
import SplashPage from '@/pages/SplashPage';
import Resources from '@/pages/Resources';
import Bookshelf from '@/pages/Bookshelf';
import JournalGuide from '@/pages/JournalGuide';
import VisionBoard from '@/pages/VisionBoard';
import Community from '@/pages/Community';
import AboutPage from '@/pages/AboutPage';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import Dashboard from '@/pages/Dashboard';
import Courses from '@/pages/Courses';
import CourseDetail from '@/pages/CourseDetail';
import LessonReader from '@/pages/LessonReader';
import Coach from '@/pages/Coach';
import Journal from '@/pages/Journal';
import Unlock from '@/pages/Unlock';
import Certificate from '@/pages/Certificate';
import Admin from '@/pages/Admin';
import LegalPage from '@/pages/LegalPage';
import SupportPage from '@/pages/SupportPage';
import GamesHub from '@/pages/games/GamesHub';
import ThoughtDefense from '@/pages/games/ThoughtDefense';
import ReframeBattle from '@/pages/games/ReframeBattle';
import BreathRhythm from '@/pages/games/BreathRhythm';
import StreakTree from '@/pages/games/StreakTree';
import InnerBattleBrain from '@/pages/games/InnerBattleBrain';
import Leaderboard from '@/pages/games/Leaderboard';
import CustomPage from '@/pages/CustomPage';
import RealTalk from '@/pages/RealTalk';
import Oracle from '@/pages/Oracle';
import Forge from '@/pages/Forge';
import ProofOfLife from '@/pages/ProofOfLife';
import Radio from '@/pages/Radio';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<SplashPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/learn/:lessonId" element={<LessonReader />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/bookshelf" element={<Bookshelf />} />
              <Route path="/journal-guide" element={<JournalGuide />} />
              <Route path="/vision-board" element={<VisionBoard />} />
              <Route path="/community" element={<Community />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/unlock" element={<Unlock />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/games" element={<GamesHub />} />
              <Route path="/games/leaderboard" element={<Leaderboard />} />
              <Route path="/games/thought-defense" element={<ThoughtDefense />} />
              <Route path="/games/reframe-battle" element={<ReframeBattle />} />
              <Route path="/games/breath-rhythm" element={<BreathRhythm />} />
              <Route path="/games/streak-tree" element={<ProtectedRoute><StreakTree /></ProtectedRoute>} />
              <Route path="/games/inner-battle" element={<ProtectedRoute><InnerBattleBrain /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/coach" element={<ProtectedRoute><Coach /></ProtectedRoute>} />
              <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
              <Route path="/certificate" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              <Route path="/videos" element={<RealTalk />} />
              <Route path="/oracle" element={<Oracle />} />
              <Route path="/forge" element={<Forge />} />
              <Route path="/proof" element={<ProofOfLife />} />
              <Route path="/radio" element={<Radio />} />
              <Route path="/p/:slug" element={<CustomPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors={false} closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
